import {DivDataTable, DivFilter} from "../../user/list/styles";
import {ButtonLogin} from "../../auth/login/styles";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import {EEnvironmentType, EFilterColumns, IEnvironment, IEnvironmentRequestTO} from "../../../models/environment";
import {EnvironmentService} from "../../../services/environment-service";
import DataTableEnv from "../../../components/data-table-env";
import PageContainer from "../../../components/page-container";
import PageTitle from "../../../components/page-title";
import DataTablePagination from "../../../components/table-pagination";
import { IFilter } from "../../../models/filter";
import {Order} from "../../../interfaces/table-head";
import Filter from "../../../components/filter";


export default function ListEnvironment() {
  const navigate = useNavigate();
  const [data, setData] = useState<IEnvironment[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState<IFilter[]>([]);

  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [loading, setLoading] = useState(true);

  const getEnvironment = async () => {
    const objeto: IEnvironmentRequestTO = {};

    for (const filter of filters) {
      if (filter.field === "Url"){
        objeto.baseUrl = filter.value as string;
      }
      if (filter.field === "Nome"){
        objeto.name = filter.value as string;
      }
      if (filter.field === "Usuário"){
        objeto.username = filter.value as string;
      }
      if (filter.field === "Status"){
        objeto.active = filter.value as boolean;
      }
      if (filter.field === "Tipo"){
        objeto.environmentType = filter.value as EEnvironmentType;
      }
    }

    setLoading(true);
    const response = await EnvironmentService
      .getAllEnvironments({
        page: page,
        size: rowsPerPage,
        sort: orderBy + "," + order
      },
      objeto
      );
    if (typeof response?.content === "object") {
      setData(response.content);
      setCount(response.totalElements);
    }
    setLoading(false);
  };

  const handleClick = () => {
    navigate("/environments/cadastrar");
  };

  useEffect(() => {
    getEnvironment();
  }, [page, rowsPerPage, orderBy, order, filters]);

  return (
    <PageContainer>
      <PageTitle>Lista de Ambientes</PageTitle>
      <DivFilter>
      <Filter filters={filters} setFilters={setFilters} fields={[
          {
            columnName: EFilterColumns.NAME,
            valueType: "text"
          },
          {
            columnName: EFilterColumns.URL,
            valueType: "text"
          },
          {
            columnName: EFilterColumns.USER,
            valueType: "text"
          },
          {
            columnName: EFilterColumns.ENVIRONMENT_TYPE,
            valueType: "select",
            options: [
              {
                label: "Produção",
                value: "PRD"
              },
              {
                label: "Homologação",
                value: "HML"
              },
              {
                label: "Desenvolvimento",
                value: "DEV"
              }
            ]
          },
          {
            columnName: EFilterColumns.STATUS,
            valueType: "select",
            options: [
              {
                label: "Ativo",
                value: "true"
              },
              {
                label: "Inativo",
                value: "false"
              }
            ]
          }
        ]}/>
        <ButtonLogin onClick={handleClick}> Cadastrar </ButtonLogin>
      </DivFilter>
      <DivDataTable>
        <DataTableEnv data={data} setOrder={setOrder}
                      setOrderBy={setOrderBy}
                      update={getEnvironment}
                      order={order}
                      orderBy={orderBy}
                      loading={loading} />
      </DivDataTable>
      <DataTablePagination page={page}
                           setPage={setPage}
                           setRowsPerPage={setRowsPerPage}
                           rowsPerPage={rowsPerPage} count={count}/>
    </PageContainer>
  );
}
